import Dashboard from './views/dashboard';


export default [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {layout: "layoutUser", pageOrder: 1}
  }
];
